export default "__VITE_ASSET__edf58cdf__"